/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentResponse } from './search-equipment-response';


export interface SearchEquipmentResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentResponse> | null;
}

